<template>
  <div class="comp-xl-number">
    <div :style="{ width: subcol.width ?? '260px' }">
      <jw-input-group class="xl-search-input-wrap">
        <jw-select v-if="subcol.select" :style="{ width: isHideIpt ? ' 100%' : '40%' }" v-model="selectVal" @change="changeSelect" :placeholder="$t('请选择')" :allow-clear="subcol.select?.allowClear || false" :bordered="subcol.select?.bordered === false ? false : true" :options="options" :field-names="subcol.select?.dataProps" unmount-on-close>
          <template #option="{ data }">
            <span :title="data.label">
              {{ data.label }}
            </span>
          </template>
        </jw-select>
        <!-- 2023/12/20:曹建博删除 :precision="subcol.precision || 0" 高级筛选不控制小数点位数 -->
        <jw-input-number v-if="!isHideIpt" :style="{ width: subcol.select ? '60%' : '100%' }" v-model.trim="iptVal" :placeholder="subcol.placeholder || $t('请输入')" :allow-clear="subcol.allowClear === false ? false : true" @change="changeVal">
          <template v-if="subcol.prepend" #prepend>{{ subcol.prepend }}</template>
          <template v-if="subcol.append" #append>{{ subcol.append }}</template>
        </jw-input-number>
      </jw-input-group>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue';
const props = defineProps({
  subcol: {
    type: Object,
    default() {
      return {};
    }
  }
});
// 百分比字段的条件
const percentFilter = [
  {
    label: '等于',
    value: 'equals'
  },
  {
    label: '不等于',
    value: 'not_equals'
  },
  {
    label: '大于',
    value: 'greater_than'
  },
  {
    label: '小于',
    value: 'less_than'
  },
  {
    label: '大于等于',
    value: 'greater_than_equals'
  },
  {
    label: '小于等于',
    value: 'less_than_equals'
  },
  {
    label: '为空',
    value: 'null'
  },
  {
    label: '不为空',
    value: 'not_null'
  }
];

const emits = defineEmits(['cb']);
const iptVal = ref(props.subcol?.value ?? '');
const selectVal = ref(props.subcol?.select?.value || '');
const o = ref({});
// selects
const options = computed(() => percentFilter);
// 隐藏输入框
const isHideIpt = computed(() => selectVal.value === 'null' || selectVal.value === 'not_null');

watch(
  () => props.subcol,
  () => {
    iptVal.value = props.subcol?.value ?? '';
    selectVal.value = props.subcol?.select?.value || 'equals';
  },
  {
    deep: true
  }
);

// 在有select情况下 是否联动删除select值
const isLinkage = computed(() => props.subcol?.select?.isLinkage);

// input 事件
const changeVal = (v) => {
  o.value = {};
  console.log(110, v, selectVal.value);
  if (!iptVal.value && iptVal.value !== 0) {
    console.log(111, v, iptVal.value);
    o.value[props.subcol.name] = undefined;
    console.log(112, v, isLinkage.value);
    if (isLinkage.value !== false) {
      selectVal.value = '';
    }
  } else {
    console.log(113, v, iptVal.value);
    o.value[props.subcol.name] = { val: iptVal.value };
    if (props.subcol.select) {
      o.value[props.subcol.name]['selectVal'] = selectVal.value;
    }
  }
  emits('cb', o.value);
};
// select 事件
const changeSelect = (v) => {
  console.log(88, v);
  if (iptVal.value || iptVal.value === 0) {
    changeVal();
  } else if (selectVal.value === 'null' || selectVal.value === 'not_null') {
    o.value = {};
    o.value[props.subcol.name] = {};
    if (props.subcol.select) {
      o.value[props.subcol.name]['selectVal'] = selectVal.value;
    }
    emits('cb', o.value);
  }
};
</script>
<style scoped lang="less">
@import './xl-number.less';
</style>
